import { TASK_FETCHING, TASK_FAILED, TASK_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TASK_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case TASK_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case TASK_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
